import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loading_Gif from "../../Images/loading-gif.gif";
import "./Dashboard.css";
import ApiBaseUrl from "../../ApiBaseUrl/ApiBaseUrl.json";
import Select from "react-select";

function Dashboard({ setQuestions, setCandidateInfo, userEmail }) {
  const navigate = useNavigate();

  const [skills, setSkills] = useState([]);
  const [levels, setLevels] = useState([]);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    languageId: [], // multi-select skill IDs
    levelId: "", // single select skill level ID
  });

  useEffect(() => {
    fetch(`${ApiBaseUrl.ApiBaseUrl}/api/skills`)
      .then((res) => res.json())
      .then((data) => setSkills(data))
      .catch((err) => console.error("Failed to fetch skills:", err));

    fetch(`${ApiBaseUrl.ApiBaseUrl}/api/levels`)
      .then((res) => res.json())
      .then((data) => setLevels(data))
      .catch((err) => console.error("Failed to fetch levels:", err));
  }, []);

  // Handle standard input changes (text, phone)
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // For react-select single select Skill Level
  const handleLevelChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      levelId: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.languageId.length === 0 || !formData.levelId) {
      alert("Please select both skill(s) and level.");
      return;
    }

    const selectedLanguages = skills.filter((s) =>
      formData.languageId.includes(s.Id)
    );
    const selectedLevel = levels.find(
      (l) => l.Id.toString() === formData.levelId.toString()
    );

    const candidateInfo = {
      name: `${formData.firstName} ${formData.lastName}`,
      phone: formData.phone,
      email: userEmail,
      language: selectedLanguages.map((s) => s.Name).join(", "),
      level: selectedLevel?.Name,
      languageId: formData.languageId,
      levelId: formData.levelId,
    };

    setCandidateInfo(candidateInfo);
    setLoading(true);

    try {
      const response = await fetch(`${ApiBaseUrl.ApiBaseUrl}/generate-questions`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          language: selectedLanguages.map((s) => s.Name),
          level: selectedLevel?.Name,
        }),
      });

      const data = await response.json();
      setQuestions(data.questions);
      navigate("/test");
    } catch (error) {
      console.error("Error fetching questions:", error);
      alert("Failed to fetch questions.");
    } finally {
      setLoading(false);
    }
  };

  // Prepare options for react-select
  const skillOptions = skills.map((skill) => ({
    value: skill.Id,
    label: skill.Name,
  }));

  const levelOptions = levels.map((level) => ({
    value: level.Id,
    label: level.Name,
  }));

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-content">
            <img src={Loading_Gif} alt="Loading" className="loading-image" />
            <p className="loading-text">We are currently generating your customized assessment. <br/>This may take a short while — thank you for your understanding and patience.</p>
          </div>
        </div>
      )}

      <div className="form-wrapper">
        <div className="form-card">
          <h2>Enter Your Information</h2>
          <p>Please provide your details to begin the assessment.</p>
          <form onSubmit={handleSubmit}>
            <div className="form-row two-cols">
              <div className="form-group">
                <label>First Name *</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Last Name *</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>Phone Number *</label>
              <input
                type="number"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>
                Select Skill <span className="required">*</span>
              </label>
              <Select
                isMulti
                name="languageId"
                className="react-select-container"
                classNamePrefix="react-select"
                options={skillOptions}
                value={skillOptions.filter((skill) =>
                  formData.languageId.includes(skill.value)
                )}
                onChange={(selectedOptions) => {
                  setFormData((prev) => ({
                    ...prev,
                    languageId: selectedOptions
                      ? selectedOptions.map((opt) => opt.value)
                      : [],
                  }));
                }}
              />
            </div>

            <div className="form-group">
              <label>
                Select Skill Level <span className="required">*</span>
              </label>
              <Select
                name="levelId"
                className="react-select-container"
                classNamePrefix="react-select"
                options={levelOptions}
                value={levelOptions.find(
                  (level) => level.value === formData.levelId
                ) || null}
                onChange={handleLevelChange}
                placeholder="Select Skill Level"
                isClearable={false}
              />
            </div>

            <div className="form-footer">
              <button type="submit" className="submitbtn" disabled={loading}>
                Let’s Get Started →
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Dashboard;